"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5824],{

/***/ 35824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ContainerDesktop; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51396);
/* harmony import */ var react_spinners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13173);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59799);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);






const Container = ({ children , className ="" , wrapperClassName ="" , useNavbar =false , isLoader =false , useLoader =false  })=>{
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_3__/* .useIsDesktop */ .Ce)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            "bg-light_neutral10_to_dark_neutral50",
            wrapperClassName
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: [
                    "relative max-w-container mx-auto bg-white ",
                    className
                ].join(" "),
                children: [
                    children,
                    useLoader && isLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex w-full items-center justify-center h-[80vh]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spinners__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            loading: isLoader
                        })
                    })
                ]
            }),
            useNavbar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Nav_BottomNav__WEBPACK_IMPORTED_MODULE_2__/* .BottomNav */ .L, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);
const ContainerDesktop = ({ children , className ="" , classBackgroundFull ="" , useMinHeight =false , useAuto =false , customStyle =null  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `w-full ${useMinHeight ? "min-h-content" : "h-full"} ` + (classBackgroundFull ? classBackgroundFull : " bg-transparent"),
        style: customStyle != null ? customStyle : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            // className={`mx-auto !max-w-[1366px] w-[95%] ${
            className: `${useAuto ? "mx-auto !max-w-[1366px] w-[95%] " : "md:px-20"} ${classBackgroundFull ? "relative h-full" : ""} ${className}`,
            children: children ?? null
        })
    });
};


/***/ }),

/***/ 66317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ IconSearch; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51776);



// 817E8C
// 19093A
const IconSearch = ({ size =24 , color ="#817E8C" , classes ="fill-neutral-60"  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.71 20.2899L18 16.6099C19.4401 14.8143 20.1375 12.5352 19.9488 10.2412C19.7601 7.94721 18.6997 5.81269 16.9855 4.27655C15.2714 2.74041 13.0338 1.91941 10.7329 1.98237C8.43207 2.04534 6.24275 2.98747 4.61517 4.61505C2.98759 6.24263 2.04546 8.43194 1.9825 10.7328C1.91954 13.0337 2.74053 15.2713 4.27667 16.9854C5.81281 18.6996 7.94733 19.76 10.2413 19.9487C12.5353 20.1374 14.8144 19.44 16.61 17.9999L20.29 21.6799C20.383 21.7736 20.4936 21.848 20.6154 21.8988C20.7373 21.9496 20.868 21.9757 21 21.9757C21.132 21.9757 21.2627 21.9496 21.3846 21.8988C21.5065 21.848 21.6171 21.7736 21.71 21.6799C21.8903 21.4934 21.991 21.2442 21.991 20.9849C21.991 20.7256 21.8903 20.4764 21.71 20.2899ZM11 17.9999C9.61556 17.9999 8.26218 17.5894 7.11103 16.8202C5.95989 16.051 5.06268 14.9578 4.53287 13.6787C4.00306 12.3996 3.86443 10.9921 4.13453 9.63427C4.40463 8.27641 5.07131 7.02912 6.05028 6.05016C7.02925 5.07119 8.27653 4.4045 9.63439 4.13441C10.9923 3.86431 12.3997 4.00293 13.6788 4.53275C14.9579 5.06256 16.0511 5.95977 16.8203 7.11091C17.5895 8.26206 18 9.61544 18 10.9999C18 12.8564 17.2625 14.6369 15.9498 15.9497C14.637 17.2624 12.8565 17.9999 11 17.9999Z",
            // fill={color}
            fill: theme == "dark" ? "#C29FEE" : color
        })
    });
};


/***/ }),

/***/ 43085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useAvatarStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useAvatarStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set, get)=>({
        // state
        streamAvatar: undefined,
        isAvatarFullScreen: true,
        scrollTriggeredByTop: true,
        remainingDuration: 0,
        showSidebar: false,
        showSummarySidebar: false,
        showQuizSidebar: false,
        dataAvatarGlobal: undefined,
        isScrolled: true,
        isDurationFetched: false,
        avatar: null,
        isLoadingSession: false,
        isLoadingSessionNxtx: false,
        isCourseTranscript: false,
        courseTranscript: "",
        // actions
        setStreamAvatar: (stream)=>set((state)=>({
                    streamAvatar: typeof stream === "function" ? stream(state.streamAvatar) : stream
                })),
        setIsAvatarFullScreen: (isFullScreen)=>set((state)=>({
                    isAvatarFullScreen: typeof isFullScreen === "function" ? isFullScreen(state.isAvatarFullScreen) : isFullScreen
                })),
        setScrollTriggeredByTop: (isTriggered)=>set((state)=>({
                    scrollTriggeredByTop: typeof isTriggered === "function" ? isTriggered(state.scrollTriggeredByTop) : isTriggered
                })),
        setRemainingDuration: (duration)=>set((state)=>({
                    remainingDuration: typeof duration === "function" ? duration(state.remainingDuration) : duration
                })),
        setShowSidebar: (show)=>set((state)=>({
                    showSidebar: typeof show === "function" ? show(state.showSidebar) : show
                })),
        setShowSummarySidebar: (show)=>set((state)=>({
                    showSummarySidebar: typeof show === "function" ? show(state.showSummarySidebar) : show
                })),
        setShowQuizSidebar: (show)=>set((state)=>({
                    showQuizSidebar: typeof show === "function" ? show(state.showQuizSidebar) : show
                })),
        setDataAvatarGlobal: (data)=>set((state)=>({
                    dataAvatarGlobal: typeof data === "function" ? data(state.dataAvatarGlobal) : data
                })),
        setIsScrolled: (isScrolled)=>set((state)=>({
                    isScrolled: typeof isScrolled === "function" ? isScrolled(state.isScrolled) : isScrolled
                })),
        setIsDurationFetched: (isFetched)=>set((state)=>({
                    isDurationFetched: typeof isFetched === "function" ? isFetched(state.isDurationFetched) : isFetched
                })),
        setAvatar: (avatar)=>set({
                avatar
            }),
        handleInterrupt: async ()=>{
            const avatar = get().avatar;
            if (!avatar) {
                console.error("Avatar API not initialized");
                return;
            }
            try {
                await avatar.interrupt();
            } catch (e) {
                console.error(e.message);
            }
        },
        setIsLoadingSession: (isLoadingSession)=>set((state)=>({
                    isLoadingSession: typeof isLoadingSession === "function" ? isLoadingSession(state.isLoadingSession) : isLoadingSession
                })),
        setIsLoadingSessionNxtx: (isLoadingSessionNxtx)=>set((state)=>({
                    isLoadingSessionNxtx: typeof isLoadingSessionNxtx === "function" ? isLoadingSessionNxtx(state.isLoadingSessionNxtx) : isLoadingSessionNxtx
                })),
        setIsCourseTranscript: (isCourseTranscript)=>set((state)=>({
                    isCourseTranscript: typeof isCourseTranscript === "function" ? isCourseTranscript(state.isCourseTranscript) : isCourseTranscript
                })),
        setCourseTranscript: (courseTranscript)=>set((state)=>({
                    courseTranscript: typeof courseTranscript === "function" ? courseTranscript(state.courseTranscript) : courseTranscript
                }))
    }));


/***/ }),

/***/ 96937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useSystemStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useSystemStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        allThemes: [
            {
                id: "light",
                icon: "light",
                active: true
            },
            {
                id: "dark",
                icon: "dark",
                active: false
            },
            {
                id: "system",
                icon: "system",
                active: false
            }
        ],
        theme: "light",
        // actions
        setTheme (a) {
            set({
                theme: a
            });
        },
        setAllTheme (a) {
            set({
                allThemes: a
            });
        }
    }));


/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ SkeletonRect; },
/* harmony export */   "nR": function() { return /* binding */ SkeletonWrapper; },
/* harmony export */   "s7": function() { return /* binding */ SkeletonCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);


const SkeletonRect = ({ className =""  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `bg-neutral-20 rounded-2 ${className}`
    });
};
const SkeletonCircle = ({ className ="" , size =32  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `bg-neutral-20 rounded-full ${className}`,
        style: {
            width: size + "px",
            height: size + "px"
        }
    });
};
const SkeletonWrapper = ({ className ="" , children  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `animate-pulse ${className}`,
        children: children
    });
};


/***/ }),

/***/ 51396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ BottomNav; },
  "e": function() { return /* binding */ iconColor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./src/components/PageHeader/systemStore.ts
var systemStore = __webpack_require__(96937);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(67832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
;// CONCATENATED MODULE: ./src/components/Icon/IconDashboard.tsx




const IconDashboard = ({ icon ="/images/dashboard-outline.png" , size =24  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "dashboard",
        src: icon,
        width: size,
        height: size,
        className: theme === "dark" ? "invert brightness-0" : ""
    });
};

// EXTERNAL MODULE: ./src/components/InteractiveAvatar/avatarStore.ts
var avatarStore = __webpack_require__(43085);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 218 modules
var motion = __webpack_require__(32977);
;// CONCATENATED MODULE: ./src/components/Icon/IconGaiaMenu.tsx






const IconGaiaMenu = ({ icon ="/images/gaia-menu-inactive.png" , size =40  })=>{
    const router = (0,next_router.useRouter)();
    const { isLoadingSessionNxtx  } = (0,avatarStore/* useAvatarStore */.z)();
    const variants = {
        squeezeBoth: {
            scale: [
                1,
                0.8,
                1.1,
                0.8,
                1
            ],
            borderRadius: [
                `${size * 0.2}px`,
                `${size * 0.3}px`,
                `${size * 0.2}px`,
                `${size * 0.3}px`,
                `${size * 0.2}px`
            ]
        }
    };
    const imageSrc = router.query.openGaia === "true" && !isLoadingSessionNxtx ? "/nexa-icon.svg" : "/nexa-icon-neutral.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-full h-full flex justify-center items-center",
        children: isLoadingSessionNxtx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            variants: variants,
            animate: "squeezeBoth",
            transition: {
                duration: 2,
                ease: "easeInOut",
                repeat: Infinity,
                repeatType: "loop"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "nexa_menu",
                src: imageSrc,
                width: size,
                height: size
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: "nexa_menu",
            src: imageSrc,
            width: size,
            height: size
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconHome.tsx




const IconHome = ({ icon ="/images/home-outline.png" , size =24  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "home",
        src: icon,
        width: size,
        height: size,
        className: theme === "dark" ? "invert brightness-0" : ""
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconLeaderboard.tsx




const IconLeaderboard = ({ icon ="/images/leaderboard-outline.png" , size =24  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "leaderboard",
        src: icon,
        width: size,
        height: size,
        className: theme === "dark" ? "invert brightness-0" : ""
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/IconMyClass.tsx




const IconMyClass = ({ icon ="/images/my-class-outline.png" , size =24  })=>{
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "my-class",
        src: icon,
        width: size,
        height: size,
        className: theme === "dark" ? "invert brightness-0" : ""
    });
};

// EXTERNAL MODULE: ./src/components/Icon/IconSearch.tsx
var IconSearch = __webpack_require__(66317);
// EXTERNAL MODULE: ./src/components/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(9978);
// EXTERNAL MODULE: ./src/lib/amplitude.ts + 1 modules
var amplitude = __webpack_require__(41272);
// EXTERNAL MODULE: ./src/lib/const.ts
var lib_const = __webpack_require__(5173);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(99601);
// EXTERNAL MODULE: ./src/lib/host.ts
var host = __webpack_require__(35304);
// EXTERNAL MODULE: ./src/lib/object.ts
var object = __webpack_require__(12582);
// EXTERNAL MODULE: ./src/lib/ssr.ts
var ssr = __webpack_require__(11927);
// EXTERNAL MODULE: ./src/modules/Auth/authStore.ts
var authStore = __webpack_require__(40474);
// EXTERNAL MODULE: ./src/modules/Tenant/homeTenantApi.ts
var homeTenantApi = __webpack_require__(97684);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(86880);
;// CONCATENATED MODULE: ./src/modules/Nav/BottomNav.tsx























const iconColor = {
    default: "#817E8C",
    selected: "#19093A"
};
const labelColor = {
    default: "text-neutral-50 text-c1 font-light text-center",
    selected: "text-purple-80 text-c1 font-bold text-center"
};
const BottomNav = ({ isDesktop , isVisible , className  })=>{
    const subDomain = (0,ssr/* isBrowser */.j)() ? (0,host/* getSubDomain */.ZC)(window.location.hostname) : null;
    const loginState = (0,authStore/* useAuthStore */.t)((state)=>state.loginState);
    const router = (0,next_router.useRouter)();
    const isTenant = (0,host/* useIsTenant */.we)();
    const isSubdomainTenant = (0,host/* useIsSubdomain */.Do)();
    const currentUser = (0,authStore/* useAuthStore */.t)((state)=>state.currentUser);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const theme = (0,systemStore/* useSystemStore */.m)((state)=>state.theme);
    const isBlueBirdTenant =  true && ((0,host/* isBlueBirdURL */.TJ)(window.location.hostname) || (0,host/* isSubdomainBluebird */.ok)(window.location.hostname));
    const referralCode = (0,helper/* getCookie */.ej)("ref_code_gk") && (0,helper/* getCookie */.ej)("ref_code_gk") !== "null" ? (0,helper/* getCookie */.ej)("ref_code_gk") :  true ? new URLSearchParams(window.location.search).get("referral") : 0;
    const [menus, setMenus] = (0,react.useState)([
        {
            id: "my-home",
            href: "/",
            label: "Home"
        },
        {
            id: "my-account",
            href: loginState == "LOGIN" ? "/account" : "/login?url=account",
            label: "Akun Saya"
        }
    ]);
    const trackNavbar = (type)=>{
        (0,amplitude/* trackEvent */.L9)({
            event: "nav_a",
            property: {
                button_type: type,
                page: router.pathname
            }
        });
        (0,amplitude/* trackEventGTM */.hk)({
            event: "nav_a",
            property: {
                button_type: type,
                page: router.pathname
            }
        });
        (0,amplitude/* trackEventGA */.w7)({
            event: "nav_a",
            property: {
                button_type: type,
                page: router.pathname
            }
        });
    };
    const gaiaAccess = (0,homeTenantApi/* useAccessGaiaTenant */.M1)();
    const [isGaiaAccess, setIsGaiaAccess] = (0,react.useState)(true);
    const [isGaiaLoading, setIsGaiaLoading] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        if (currentUser) {
            setIsGaiaLoading(true);
            gaiaAccess.doFetch({
                slug: currentUser?.referral ?? subDomain
            }, {
                onSuccess (data) {
                    setIsGaiaAccess(checkGaiaAccess(data?.data, currentUser));
                    setIsGaiaLoading(false);
                },
                onError () {
                    setIsGaiaLoading(false);
                }
            });
        }
    }, [
        currentUser
    ]);
    function checkGaiaAccess(accessData, user) {
        const groupedAccess = {
            positions: [],
            workUnits: [],
            locations: []
        };
        let isUserAccess = false;
        accessData.forEach((access)=>{
            const accessType = access.access_type.name;
            const isExactUser = access.is_exact_user;
            const isOpenToEveryone = access.is_open_to_everyone;
            if (accessType === "User" && (isExactUser || isOpenToEveryone)) {
                isUserAccess = true;
            }
            const typeData = access.type_json_data || {};
            if (typeData.positions) {
                groupedAccess.positions.push(...typeData.positions);
            }
            if (typeData.work_units) {
                groupedAccess.workUnits.push(...typeData.work_units);
            }
            if (typeData.locations) {
                groupedAccess.locations.push(...typeData.locations);
            }
        });
        const allowedPositions = groupedAccess.positions.map((p)=>p?.position).filter(Boolean);
        const allowedWorkUnits = groupedAccess.workUnits.map((wu)=>wu?.work_unit).filter(Boolean);
        const allowedLocations = groupedAccess.locations.map((loc)=>loc?.location).filter(Boolean);
        const hasPositionAccess = allowedPositions.includes(user?.profile?.position);
        const hasWorkUnitAccess = allowedWorkUnits.includes(user?.profile?.work_unit);
        const hasLocationAccess = allowedLocations.includes(user?.profile?.location);
        return isUserAccess || hasPositionAccess || hasWorkUnitAccess || hasLocationAccess;
    }
    // Allowing list of client to show leaderboard
    const clientLeaderboards = [
        "kemenperin",
        "demoplus",
        "umkm",
        "desa",
        "wonderfullearning",
        "kapalapi",
        "ppsdmaparatur",
        "kemkes"
    ];
    const isB2B = (0,host/* useIsSubdomain */.Do)() || (0,host/* useIsTenant */.we)();
    const [isGaiaEnabled, setIsGaiaEnabled] = (0,react.useState)(false);
    // @ts-ignore
    const getSubdomainAPI = (0,homeTenantApi/* useGetSubdomainData */.mq)();
    const { tenantData , setTenantData  } = (0,authStore/* useAuthStore */.t)();
    (0,react.useEffect)(()=>{
        getSubdomainAPI.doFetch({
            slug: window.location.hostname === "e-learning.bluebirdgroup.com" ? "bluebird" : currentUser?.referral ?? subDomain
        }, {
            onSuccess (data) {
                setTenantData(data?.data);
            }
        });
    }, [
        currentUser,
        subDomain
    ]);
    (0,react.useEffect)(()=>{
        if (tenantData) {
            setIsGaiaEnabled(tenantData.setting.is_heygen_enabled);
        }
    }, [
        tenantData
    ]);
    const [isLeaderboard, setIsLeaderboard] = (0,react.useState)(false);
    const [isPIC, setIsPIC] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (currentUser && currentUser?.dashboard_url && menus.length && !menus.some((a)=>a.id == "dashboard")) {
            setIsPIC(true);
        }
    }, [
        currentUser
    ]);
    (0,react.useEffect)(()=>{
        if (currentUser?.tenant?.status === "Trial" || clientLeaderboards.includes(currentUser?.referral) || lib_const/* CONST.IS_DEV */.o.IS_DEV || isB2B && currentUser?.referral !== "bluebird") {
            setIsLeaderboard(true);
        }
    }, [
        currentUser,
        isB2B
    ]);
    const { t  } = (0,useTranslation/* default */.Z)("common");
    (0,react.useEffect)(()=>{
        if (isGaiaLoading) return;
        let newMenus = [
            {
                id: "my-home",
                href: "/",
                label: "Home"
            }
        ];
        // if (currentUser && !isPIC && isLeaderboard) {
        //   newMenus.push({
        //     id: "my-class",
        //     href: "/my-class",
        //     label: "Kelas Saya",
        //   });
        // }
        if (currentUser && (isPIC || !isPIC && !isGaiaAccess && !isGaiaEnabled)) {
            newMenus.push({
                id: "my-class",
                href: "/my-class",
                label: "Kelas Saya"
            });
        }
        if (currentUser && isGaiaAccess && isGaiaEnabled) {
            newMenus.push({
                id: "gaia",
                href: "?openGaia=true",
                label: "GAIA"
            });
        }
        // if (currentUser && isLeaderboard) {
        //   newMenus.push({
        //     id: "leaderboard",
        //     href: "/leaderboard",
        //     label: "Leaderboard",
        //   });
        // }
        if (currentUser && isPIC) {
            newMenus.push({
                id: "dashboard",
                href: "/dashboard",
                label: "Dashboard"
            });
        }
        newMenus.push({
            id: "my-account",
            href: loginState == "LOGIN" ? "/account" : "/login?url=account",
            label: "Akun Saya"
        });
        if (newMenus.length > 5) {
            if (isPIC) {
                newMenus = [
                    newMenus[0],
                    newMenus.find((m)=>m.id === "leaderboard") || newMenus[1],
                    newMenus[1],
                    newMenus.find((m)=>m.id === "dashboard") || newMenus[2],
                    newMenus[newMenus.length - 1]
                ];
            } else {
                newMenus = [
                    newMenus[0],
                    newMenus.find((m)=>m.id === "my-class") || newMenus[1],
                    newMenus[1],
                    newMenus.find((m)=>m.id === "leaderboard") || newMenus[2],
                    newMenus[newMenus.length - 1]
                ];
            }
        }
        if (newMenus.length % 2 === 1) {
            const middleIndex = Math.floor(newMenus.length / 2);
            const gaiaIndex = newMenus.findIndex((m)=>m.id === "gaia");
            if (gaiaIndex !== -1 && gaiaIndex !== middleIndex) {
                const [gaia] = newMenus.splice(gaiaIndex, 1);
                newMenus.splice(middleIndex, 0, gaia);
            }
        }
        setMenus(newMenus);
    }, [
        isGaiaLoading,
        currentUser,
        isSubdomainTenant,
        isTenant,
        isGaiaAccess,
        isPIC,
        isLeaderboard
    ]);
    (0,react.useEffect)(()=>{
        setIsLoading(false);
    }, []);
    const renderUser = (bgColor, textColor)=>{
        const initialName = currentUser?.name ? currentUser?.name[0].toUpperCase() ?? "U" : currentUser?.email ? currentUser?.email[0].toUpperCase() ?? "U" : "U";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: `bg-[${bgColor}] cursor-pointer w-24 h-24 rounded-full flex items-center justify-center text-b1 text-violet_main`,
            children: initialName
        });
    };
    const { isLoadingSessionNxtx  } = (0,avatarStore/* useAvatarStore */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `fixed z-[100] bottom-0 left-0 right-0 transition-transform duration-1000 ${isVisible ? "translate-y-0" : "translate-y-[100px]"}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "flex justify-center z-10 bg-light_neutral10_to_dark_neutral50 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-[64px] bg-white flex items-center justify-evenly px-8 gap-12 border-t border-neutral20_to_dark30",
                    children: menus && menus.length && !isLoading ? (0,object/* ReduceArrayFromDuplicate */.zp)(menus).map((menu)=>{
                        let colors = router.pathname == menu.href && !router.query.openGaia ? iconColor.selected : iconColor.default;
                        let labels = router.pathname == menu.href && !router.query.openGaia ? labelColor.selected : labelColor.default;
                        let icons = router.pathname == menu.href && !router.query.openGaia ? `/images/${menu.id}-fill.png` : `/images/${menu.id}-outline.png`;
                        let bgColor = router.pathname == menu.href ? "#19093A" : "#fff";
                        let textColor = router.pathname == menu.href ? "#fff" : "#19093A";
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: ()=>{
                                if (menu.id === "gaia") {
                                    const currentQuery = {
                                        ...router.query
                                    };
                                    if (currentQuery.openGaia === "true") {
                                        delete currentQuery.openGaia;
                                    } else {
                                        currentQuery.openGaia = "true";
                                    }
                                    // @ts-ignore
                                    router.push({
                                        pathname: router.pathname,
                                        query: currentQuery
                                    }, undefined, {
                                        shallow: true
                                    });
                                } else {
                                    //@ts-ignore
                                    router.push(menu.href);
                                    trackNavbar(menu.label);
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "p-5 w-fit",
                                children: {
                                    "my-home": /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHome, {
                                                icon: icons
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: t(menu.label)
                                            })
                                        ]
                                    }),
                                    "my-search": /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* IconSearch */.j, {
                                                color: colors,
                                                classes: "m-auto"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: t(menu.label)
                                            })
                                        ]
                                    }),
                                    "my-class": /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMyClass, {
                                                icon: icons
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: t(menu.label)
                                            })
                                        ]
                                    }),
                                    gaia: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-[40px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "absolute -bottom-[18px] flex flex-col gap-4 items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGaiaMenu, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: router.query.openGaia === "true" && !isLoadingSessionNxtx ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "nexa",
                                                        src: "/nexa-text-icon.svg",
                                                        width: 33,
                                                        height: 14
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        alt: "nexa",
                                                        src: "/nexa-text-icon-neutral.svg",
                                                        width: 33,
                                                        height: 14
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    leaderboard: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLeaderboard, {
                                                icon: icons
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: t(menu.label)
                                            })
                                        ]
                                    }),
                                    dashboard: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDashboard, {
                                                icon: icons
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: menu.label
                                            })
                                        ]
                                    }),
                                    "my-account": /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-2 place-items-center",
                                        children: [
                                            renderUser(bgColor, textColor),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: labels,
                                                children: t(menu.label)
                                            })
                                        ]
                                    })
                                }[menu.id]
                            })
                        }, "Nav-" + menu.id);
                    }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonWrapper */.nR, {
                        className: "grid grid-cols-5 p-5 gap-8",
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5
                        ].map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* SkeletonRect */.a8, {
                                className: "rounded-4 h-48 w-80"
                            }, el))
                    }) : null
                })
            }),
            isBlueBirdTenant && !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b border-b-neutral20_to_dark30"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-white flex justify-center items-center gap-8 py-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-b2 font-light text-neutral50_to_dark20",
                                children: "Powered by"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: theme == "dark" ? "/logo-white-2048.png" : "/logo-2048.png",
                                alt: "learnext",
                                width: 70,
                                height: 21
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 97684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GL": function() { return /* binding */ useGetVillages; },
/* harmony export */   "HL": function() { return /* binding */ useGetCoursesByTenantSlug; },
/* harmony export */   "M1": function() { return /* binding */ useAccessGaiaTenant; },
/* harmony export */   "So": function() { return /* binding */ useJPTrackers; },
/* harmony export */   "e0": function() { return /* binding */ useRequestUpgradeTenant; },
/* harmony export */   "mq": function() { return /* binding */ useGetSubdomainData; }
/* harmony export */ });
/* unused harmony exports useGetSubdomainTenant, useGetCoursesMandatoryByTenantSlug, useGetDashboardReport, useGetSectionCustomByTenantSlug, useGetOthersByTenantSlug, useGetSectionDetail, useGetSectionMandatoryDetail, useGetAvatarClick, useAvatarClick, useGetAvatarLogChat, useAvatarLogChat, useRequestAvatarQuota, useGetCoursesUserRecomendations, useLeaderboardTenant */
/* harmony import */ var lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49208);

const useGetCoursesByTenantSlug = ()=>//@ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}/courses");
const useGetSubdomainTenant = (additionalKey)=>//@ts-ignore
    useApi("get", "/tenants/{slug}/subdomain", additionalKey);
const useRequestUpgradeTenant = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("post", "/tenants/upgrade");
const useGetSubdomainData = (additionalKey)=>//@ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}", additionalKey);
const useGetCoursesMandatoryByTenantSlug = (additionalKey)=>useApi("get", "/tenants/{slug}/course-mandatories", additionalKey);
const useGetDashboardReport = (additionalKey)=>useApi("post", "/tenants/{slug}/dashboard-report", additionalKey);
const useGetSectionCustomByTenantSlug = (additionalKey)=>// @ts-ignore
    useApi("get", "/tenants/{slug}/sections", additionalKey);
const useGetOthersByTenantSlug = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/course-others");
const useGetSectionDetail = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/sections/{section}/show");
const useGetSectionMandatoryDetail = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/course-mandatories/{course_mandatory}/show");
// @ts-ignore
const useGetVillages = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}/villages");
// @ts-ignore
const useJPTrackers = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/user-learning-hours");
const useGetAvatarClick = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/avatar-click");
const useAvatarClick = ()=>// @ts-ignore
    useApi("post", "/tenants/{slug}/avatar-click");
const useGetAvatarLogChat = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/avatar-log-chat");
const useAvatarLogChat = ()=>// @ts-ignore
    useApi("post", "/tenants/{slug}/avatar-log-chat");
const useRequestAvatarQuota = ()=>// @ts-ignore
    useApi("post", "/tenants/{slug}/request-quota-gaia");
const useGetCoursesUserRecomendations = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/courses/user-recommendations");
const useAccessGaiaTenant = ()=>// @ts-ignore
    (0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/tenants/{slug}/gaia-access");
const useLeaderboardTenant = ()=>// @ts-ignore
    useApi("get", "/tenants/{slug}/leaderboard");


/***/ })

}]);